import { render } from "./SystemMenuImage.vue?vue&type=template&id=3c8027ee&scoped=true"
import script from "./SystemMenuImage.vue?vue&type=script&lang=js"
export * from "./SystemMenuImage.vue?vue&type=script&lang=js"

import "./SystemMenuImage.vue?vue&type=style&index=0&id=3c8027ee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8027ee"]])

export default __exports__